import {
  fetch as fetchApi,
  insert as insertApi,
  drop as dropApi,
  isString,
} from "./api";
import { BranchCodec, Branch, Data } from "../store/branch/types";
import { withDecoded, flattenData } from "./";

function mapToModel(data: object): Branch {
  return withDecoded(BranchCodec, data, (decoded) => ({
    ...decoded,
  }));
}

export async function fetch(
  id?: string | null,
  params?: {}
): Promise<Branch> {
  return fetchApi({
    nestedResourcePath: ["branch"],
    id: id,
    params: params,
  }).then((response) =>
    mapToModel(
      flattenData(
        isString(response.data) ? JSON.parse(response.data) : response.data
      )
    )
  );
}

export async function save(group: Data): Promise<Branch> {
  return insertApi({
    nestedResourcePath: ["branch"],
    id: group.id,
    data: { data: group },
  }).then((response) =>
    mapToModel(
      flattenData(
        isString(response.data) ? JSON.parse(response.data) : response.data
      )
    )
  );
}

export async function drop(id: string | null): Promise<any> {
  return dropApi({
    nestedResourcePath: ["branch"],
    id: id,
  }).then((response) => response.data);
}
